import { trans } from '@spotahome/soyuz/client';
import {
  formatLongReadableDate,
  getDateAsUTC
} from '@spotahome/ui-library/src/tenant/components/utils/dateUtils';
import { isSameDay } from 'date-fns';

export const getHumanReadableAvailability = (
  availableFrom,
  useWithPrefix = true
) => {
  if (!availableFrom) {
    return trans('property_show.label.indefinite_occupancy');
  } else if (isSameDay(getDateAsUTC(availableFrom), getDateAsUTC(new Date()))) {
    return trans('property_show.label.available_now');
  }

  const formattedAvailableFrom = formatLongReadableDate(availableFrom);
  const prefix = useWithPrefix
    ? `${trans('property_show.label.available')}: `
    : '';

  return `${prefix}${formattedAvailableFrom}`;
};

export default {
  getHumanReadableAvailability
};
